import Alpine from "alpinejs";

Alpine.data('ModalForm', () => ({
    init() {},

    openForm(id, location) {
        if (!id) return;

        const modalBody = document.getElementById('modal-content-body');
        const sourceContainer = document.getElementById(`fa-workflow-${id}`);
        const form = sourceContainer?.querySelector('.wFormContainer') ?? modalBody?.firstChild;

        if (!modalBody || !form) return;
        
        if (!modalBody.contains(form)) {
            modalBody.innerHTML = '';
            modalBody.appendChild(form);
        }

        if (location) {
            const field = modalBody.querySelector('[class$="location"] input');
            if (field) field.value = location;
        }

    },
}));
